import React from 'react'
import './WinnersHome.css'
import testimonialimg from '../../Images/09944e80b517d6d297d3d88737870c54.jpg'
import testlogo from '../../Images/Vector (17).png'
import star from '../../Images/Group (3).png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from 'react-slick'
import previous from '../../Images/Vector (18).png'
import next from '../../Images/Vector (19).png'
const WinnersTestimonial = () => {


    const PreviousButton = ({className,onClick})=>{
        return (
            <>
                <div onClick={onClick} className='previous_outer_div'>
                    <div className='previous_inside_div'>
                        <img src={previous}/>
                    </div>
                </div>
            </>
        )
    }
    const NextButton = ({className,onClick}) =>{
        return(
            <>
               <div onClick={onClick} className='next_outer_div'>
                    <div className='previous_inside_div'>
                        <img src={next}/>
                    </div>
                </div> 
            </>
        )
    }
    var settings = { 
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: <PreviousButton />,
        nextArrow: <NextButton />
      };

  return (
    <>

      <div className='testimonial_wrapper_main'>
        <div className='testimonial_div_main'>
            <h1 className='search_cities_head'>Testimonial</h1>
<Slider {...settings}>
{[1,2,3,4,5].map((e)=>(
    <>
<div className='testimonial_slide_main'>
                <div className='testimonial_slide'>
                    <div className='testimonial_img'>
                        <img className='testimonial_img2' src={testimonialimg}/>
                        <div className='testimonial_outer_circle'>
                            <div className='testimonial_inner_circle'>
                                <img src={testlogo}/>
                            </div>
                        </div>
                    </div>

                    <div className='testimonial_star_div_wrapper'>
                       <div className='testimonial_star_div'>
                       <div className='testimonial_stars'>
                       {[1,2,3,4,5].map((e,i)=>(
                            <img key={i} className='star_img' src={star}/>
                          ))}
                       </div>
                       <p className='testimonial_rating_para'>5.0</p>
                         
                       </div>
                       <p className='testimonial_para'>Lorem Ipsum placeholder text for use in your graphic, print and web layouts, and discover plugins for your favorite writing, design and blogging tools. Explore the origins, history and meaning of the famous passage  Lorem Ipsum placeholder text for use in your graphic, print and web layouts, and discover plugins for your favorite writing, design and blogging tools. Explore the origins, history and meaning of the famous passage</p>
                       <p className='testimonial_name'>Sumit Jaiswal</p>
                       <p className='testimonial_work'>UI/UX Designer</p>
                    </div>
                </div>
            </div>
</>
))}



</Slider>

        </div>
      </div>
    </>
  )
}

export default WinnersTestimonial
